import { render, staticRenderFns } from "./RegistrarEnvioImagenes.vue?vue&type=template&id=7ac28584"
import script from "./RegistrarEnvioImagenes.vue?vue&type=script&lang=js"
export * from "./RegistrarEnvioImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports